/* InputSearchControlComponent.js */

"use strict";

const InputBaseControlTextfieldComponent = require("@gluenetworks/input_base_control").Textfield;
const Renderer = require("./InputSearchControlRenderer");
const _ = require("lodash");

class InputSearchControlComponent extends InputBaseControlTextfieldComponent {
    /**
     * @schema.name Input Search Control
     * @schema.package @gluenetworks/input_search_control
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.Textfield.InputSearch
     * @schema.events ["Placeholder", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.placeholder.name placeholder
     * @schema.configuration.placeholder.type string
     * @schema.configuration.placeholder.default "Search"
     * @schema.configuration.placeholder.required false
     *
     * @schema.configuration.mode.name mode
     * @schema.configuration.mode.type string
     * @schema.configuration.mode.default "search"
     * @schema.configuration.mode.required false
     *
     */

    constructor(configOptions) {
        super(configOptions);

        this._DEFAULT_PLACEHOLDER = "Search";
        this._placeholder = _.get(configOptions, "placeholder", this._DEFAULT_PLACEHOLDER);

        this._mode = _.get(configOptions, "mode", "search");

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._darkTheme = undefined;
        this._theme = undefined;
        this._placeholder = undefined;
        this._DEFAULT_PLACEHOLDER = undefined;
        this._mode = undefined;
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /**
     * Trigger a change event passing the value of the control.  This event is debounced
     * in the renderer.
     * @param newVal {String}
     * @private
     */
    _triggerUserChange(newVal) {
        this.emit("UserChange", newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    /**
     * @schema.methods.setMode.name setMode
     * @schema.methods.setMode.description Sets the mode of the control and returns an instance of the control for chainability. Possible values are 'search' and 'filter'.
     * @schema.methods.setMode.returns Instance of the control
     * @schema.methods.setMode.parameters.newVal.name newVal
     * @schema.methods.setMode.parameters.newVal.description The mode of the control. Possible values are 'search' and 'filter'.
     * @schema.methods.setMode.parameters.newVal.type string
     */
    setMode(newVal) {
        this._mode = newVal;
        this.emit("Mode", this._mode);
        return this;
    }
    /**
     * @schema.methods.getMode.name getMode
     * @schema.methods.getMode.description Returns the mode of the control
     * @schema.methods.getMode.returns string
     */
    getMode() {
        return this._mode;
    }
    get mode() {
        return this.getMode();
    }
    set mode(newVal) {
        this.setMode(newVal);
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = InputSearchControlComponent;
